define('numberView',[
  'module',
  'underscore',
  'inputView',
  'template!numberView'
], function (
  Module,
  _,
  InputView,
  Tpl
) {
  'use strict';

  Module.exports = InputView.extend({
    template: Tpl,
    tagName: 'input',
    className: 'number-view ' + InputView.prototype.className,

    attributes: function () {
      return _.extend({}, InputView.prototype.attributes.apply(this, arguments), {
        'type': 'number'
      });
    },

    events: {
      'change': 'onChange'    
    },

    getValue: function () {
      return this.$el.val();
    },

    setValue: function (value) {
      this.$el.val(value);
    },    

    onChange: function(e) {
      if(this.options.onChange)
        this.options.onChange(e);
    }
  });
});
  
